<div class="load-type-header" [formGroup]="formGroup">
  <div class="form-fields-wrapper">
    <div class="form-fields">
      <div>
        <cai-load-type-quantity-input
          formControlName="pieces"
          [id]="'pieces'"
          [label]="piecesLabel"
          [unit]="'pc(s)'"
          [readonly]="disableTotals"
          [noUpdateOnBlur]="noUpdateOnBlur"
          [placeholder]="'1'"
          [floatLabel]="floatLabel"
          [disableDecimal]="true"
          [viewOnly]="viewOnly"
          (onFocus)="onFocus.emit()"
          [noUpdateOnBlur]="noUpdateOnBlur"
          [forceErrorDisplay]="displayErrors"
        >
          <object
            icon
            type="image/svg+xml"
            data="/assets/media/icons/cargo.svg"
            style="width: 20px"
          ></object>
        </cai-load-type-quantity-input>
      </div>
      <div>
        <cai-load-type-quantity-input
          formControlName="weight"
          [id]="'weight'"
          [label]="weightLabel"
          [unit]="totalUnitsState?.weightUnitCode"
          [readonly]="disableTotals"
          [placeholder]="'1.00'"
          [viewOnly]="viewOnly"
          [floatLabel]="floatLabel"
          [disableUnitSelector]="disableUnitSelector"
          [noUpdateOnBlur]="noUpdateOnBlur"
          (onFocus)="onFocus.emit()"
          [noUpdateOnBlur]="noUpdateOnBlur"
          [forceErrorDisplay]="displayErrors"
          [weightUnit]="totalUnitsState?.weightUnitDetail"
          [(selectedUnit)]="totalUnitsState.weightUnitDetail"
          [(measurementSystem)]="totalUnitsState.measurementSystem"
          (selectedUnitChange)="convertTotalWeight(totalUnitsState, $event)"
          [measurementUnits]="getMeasurementUnits(measurementTypeEnum.WEIGHT)"
        >
          <span icon>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.75 4.16667V3.2912C12.0519 3.43512 13.2423 3.94933 14.2134 4.72617L13.6364 5.30291C13.3435 5.59575 13.3434 6.07062 13.6362 6.36357C13.9291 6.65651 14.404 6.6566 14.6969 6.36376L15.274 5.78685C16.0508 6.75791 16.5649 7.94816 16.7088 9.25H15.8333C15.4191 9.25 15.0833 9.58579 15.0833 10C15.0833 10.4142 15.4191 10.75 15.8333 10.75H16.7088C16.5649 12.0518 16.0508 13.2421 15.274 14.2131L14.6969 13.6362C14.404 13.3434 13.9291 13.3435 13.6362 13.6364C13.3434 13.9294 13.3435 14.4043 13.6364 14.6971L14.2134 15.2738C13.0586 16.1976 11.5938 16.75 10 16.75C8.40626 16.75 6.94153 16.1977 5.78679 15.274L6.36387 14.6971C6.65682 14.4043 6.6569 13.9294 6.36407 13.6364C6.07123 13.3435 5.59635 13.3434 5.3034 13.6362L4.72612 14.2133C3.9493 13.2422 3.43512 12.0519 3.2912 10.75H4.16667C4.58088 10.75 4.91667 10.4142 4.91667 10C4.91667 9.58579 4.58088 9.25 4.16667 9.25H3.2912C3.43511 7.94811 3.94928 6.75781 4.72608 5.78674L5.303 6.36366C5.5959 6.65656 6.07077 6.65656 6.36366 6.36366C6.65656 6.07077 6.65656 5.5959 6.36366 5.303L5.78674 4.72608C6.75781 3.94928 7.94811 3.43511 9.25 3.2912V4.16667C9.25 4.58088 9.58579 4.91667 10 4.91667C10.4142 4.91667 10.75 4.58088 10.75 4.16667ZM10 1.75C14.5563 1.75 18.25 5.44365 18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10C1.75 5.44365 5.44365 1.75 10 1.75ZM9.99989 7.50001L10.4463 6.89734C10.1811 6.7009 9.81866 6.7009 9.55346 6.89735L9.99989 7.50001ZM9.75392 8.79975C9.83723 8.69482 9.92081 8.59973 9.9999 8.51568C10.079 8.59973 10.1626 8.69483 10.2459 8.79976C10.612 9.26079 10.9166 9.8391 10.9166 10.463C10.9166 10.9852 10.7592 11.3033 10.5939 11.4828C10.426 11.6653 10.2107 11.75 9.99994 11.75C9.78918 11.75 9.57387 11.6653 9.40593 11.4828C9.24066 11.3033 9.08327 10.9852 9.08327 10.463C9.08327 9.83908 9.38782 9.26077 9.75392 8.79975ZM12.4166 10.463C12.4166 9.35845 11.8878 8.45528 11.4206 7.86692C11.182 7.56648 10.9446 7.32917 10.7662 7.16619C10.6765 7.0843 10.6006 7.0201 10.5452 6.975C10.5175 6.95242 10.4949 6.93455 10.4781 6.92157L10.4575 6.90575L10.4507 6.90061L10.4482 6.89874L10.4472 6.89798L10.4467 6.89764C10.4465 6.89749 10.4463 6.89734 9.99989 7.50001C9.55346 6.89735 9.55326 6.8975 9.55305 6.89765L9.55259 6.89799L9.55157 6.89875L9.54907 6.90062L9.54225 6.90576L9.52162 6.92158C9.50487 6.93456 9.48222 6.95244 9.45451 6.97501C9.39916 7.02011 9.32324 7.08432 9.23361 7.16621C9.05521 7.32919 8.81782 7.56649 8.57924 7.86694C8.11203 8.4553 7.58327 9.35846 7.58327 10.463C7.58327 11.2987 7.84254 11.9992 8.30228 12.4987C8.75933 12.9952 9.37735 13.25 9.99993 13.25C10.6225 13.25 11.2405 12.9952 11.6976 12.4987C12.1573 11.9992 12.4166 11.2987 12.4166 10.463Z"
                fill="#B6B6B6"
              />
            </svg>
          </span>
        </cai-load-type-quantity-input>
      </div>
      <div>
        <cai-load-type-quantity-input
          formControlName="volume"
          [id]="'volume'"
          [label]="'Volume'"
          [unit]="volumeUnit?.VOLUME?.code"
          [decimalPlace]="4"
          [readonly]="disableTotals"
          [placeholder]="'1.00'"
          [floatLabel]="floatLabel"
          [noUpdateOnBlur]="noUpdateOnBlur"
          [viewOnly]="viewOnly"
          (onFocus)="onFocus.emit()"
          [noUpdateOnBlur]="noUpdateOnBlur"
          [forceErrorDisplay]="displayErrors"
        >
          <span icon>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.4537 1.80709C14.734 1.92318 14.9167 2.19665 14.9167 2.5V6.75H15.8334C16.2476 6.75 16.5834 7.08579 16.5834 7.5C16.5834 7.91421 16.2476 8.25 15.8334 8.25H14.1667H12.5C12.0858 8.25 11.75 7.91421 11.75 7.5C11.75 7.08579 12.0858 6.75 12.5 6.75H13.4167V4.31066L13.0304 4.697C12.7375 4.98989 12.2626 4.98989 11.9697 4.697C11.6768 4.4041 11.6768 3.92923 11.9697 3.63634L13.6364 1.96967C13.8509 1.75517 14.1735 1.691 14.4537 1.80709ZM5.83337 4.25C6.24759 4.25 6.58337 4.58579 6.58337 5V13.1893L7.80304 11.9697C8.09594 11.6768 8.57081 11.6768 8.8637 11.9697C9.1566 12.2626 9.1566 12.7374 8.8637 13.0303L6.3637 15.5303C6.22305 15.671 6.03229 15.75 5.83337 15.75C5.63446 15.75 5.4437 15.671 5.30304 15.5303L2.80304 13.0303C2.51015 12.7374 2.51015 12.2626 2.80304 11.9697C3.09594 11.6768 3.57081 11.6768 3.8637 11.9697L5.08337 13.1893V5C5.08337 4.58579 5.41916 4.25 5.83337 4.25ZM16.5834 10.8333C16.5834 10.4191 16.2476 10.0833 15.8334 10.0833H12.5C12.0858 10.0833 11.75 10.4191 11.75 10.8333V13.3333C11.75 13.7475 12.0858 14.0833 12.5 14.0833H15.0834V15.0833H12.5C12.0858 15.0833 11.75 15.4191 11.75 15.8333C11.75 16.2475 12.0858 16.5833 12.5 16.5833H15.8334C16.2476 16.5833 16.5834 16.2475 16.5834 15.8333V13.3333V10.8333ZM15.0834 11.5833V12.5833H13.25V11.5833H15.0834Z"
                fill="#B6B6B6"
              />
            </svg>
          </span>
        </cai-load-type-quantity-input>
      </div>
      <div class="chargeable-weight">
        @if (!isEditableChargeableWeight) {
          <cai-load-type-quantity-input
            formControlName="chargeableWeight"
            i18n-label="@@global.chargeable-weight"
            [id]="'chargeable-weight'"
            label="Chargeable Weight"
            [readonly]="!isEditableChargeableWeight"
            [viewOnly]="viewOnly"
            [unit]="totalUnitsState?.weightUnitCode"
            [noUpdateOnBlur]="noUpdateOnBlur"
          >
          </cai-load-type-quantity-input>
        }
        @if (isEditableChargeableWeight) {
          <cai-load-type-quantity-input
            formControlName="chargeableWeight"
            i18n-label="@@global.chargeable-weight"
            [unit]="totalUnitsState?.weightUnitCode"
            [id]="'chargeable-weight'"
            label="Chargeable Weight"
            [weightUnit]="totalUnitsState?.weightUnitDetail"
            [readonly]="!isEditableChargeableWeight"
            [viewOnly]="viewOnly"
            [unit]="totalUnitsState?.weightUnitCode"
            [noUpdateOnBlur]="noUpdateOnBlur"
            [(selectedUnit)]="totalUnitsState.weightUnitDetail"
            [(measurementSystem)]="totalUnitsState.measurementSystem"
            (selectedUnitChange)="
              handleChargeableUnitChange(totalUnitsState, $event)
            "
            [measurementUnits]="getMeasurementUnits(measurementTypeEnum.WEIGHT)"
          >
          </cai-load-type-quantity-input>
        }
      </div>
    </div>
  </div>
  <div class="mode-switch" [class.bupSwitch]="loadTypeSwitchClass">
    <cai-load-type-switch
      [class.invisible]="viewOnly"
      [mode]="loadTypeMode"
      (onModeChange)="changeMode($event)"
    ></cai-load-type-switch>
  </div>
</div>
<div class="errors-container">
  @for (error of errorMessage; track error; let i = $index) {
    <span class="error-msg">
      {{ error }}
    </span>
  }
</div>

@if (showDimensions || showBUP) {
  <div class="load-type-body">
    <div class="load-type-border"></div>
    <div class="load-type-table">
      @if (showDimensions) {
        <cai-load-type-dimension
          [enableUnitSwitch]="enableUnitSwitch"
          [dimensions]="dimensions"
          (dimensionsChange)="dimensionsChange.emit($event)"
          [measurementUnit]="measurementUnit"
          (onUpdateTotals)="updateTotals()"
          (onFocus)="onFocus.emit()"
          [noUpdateOnBlur]="noUpdateOnBlur"
          [(weightUnit)]="dimensionUnitsState.weightUnitDetail"
          (weightUnitChange)="convertTotalWeight(dimensionUnitsState, $event)"
          [defaultMeasurementSystem]="defaultMeasurementSystem"
          [(dimensionUnit)]="dimensionUnitsState.dimensionUnitDetail"
          [(dimensionUnitsState)]="loadTypeUnitState[loadTypeEnum.DIMENSIONS]"
          (dimensionUnitChange)="handleDimensionUnitChange($event)"
          [(measurementSystem)]="dimensionUnitsState.measurementSystem"
          [chargeableUnitChangeCount]="chargeableUnitChangeCount"
          [mode]="loadTypeMode"
        ></cai-load-type-dimension>
      }
      @if (showBUP) {
        <cai-load-type-bup
          [enableUnitSwitch]="enableUnitSwitch"
          [origMeasurementSystem]="measurementSystem"
          [bups]="bups"
          (bupsChange)="bupsChange.emit($event)"
          [(weightUnit)]="bupUnitsState.weightUnitDetail"
          (weightUnitChange)="convertTotalWeight(bupUnitsState, $event)"
          [defaultMeasurementSystem]="defaultMeasurementSystem"
          [(measurementSystem)]="bupUnitsState.measurementSystem"
          [chargeableUnitChangeCount]="chargeableUnitChangeCount"
          [mode]="loadTypeMode"
          (onUpdateTotals)="updateTotals()"
        >
        </cai-load-type-bup>
      }
    </div>
  </div>
}
